// src/pages/leaderboards/index.tsx
import { NextPage } from "next";
import Head from "next/head";
import { LeaderboardLanding } from "components/organisms/LeaderboardLanding";
const Leaderboard: NextPage = () => {
  return <>
            <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
                <title>
                    CharGen Leaderboards: Top AI Image Generator of the Month
                </title>
                <meta name="description" content="Explore the Best AI Image Generator for Fantasy AI Art Generator contributors in the CharGen community. See who is creating the most popular AI-generated D&D character art." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:description" key="og:description" content="Explore the Best AI Image Generator for Fantasy AI Art Generator contributors in the CharGen community. See who is creating the most popular AI-generated D&D character art." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:url" key="og:url" content="https://char-gen.com/leaderboards" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
            </Head>
            <LeaderboardLanding data-sentry-element="LeaderboardLanding" data-sentry-source-file="index.tsx" />
        </>;
};
export default Leaderboard;